module.exports = __webpack_public_path__ + "static/media/trash-alt.87d6c53b.svg";